module.exports = new __parcel__URL__("weather-fc.f492782d.png").toString();